import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder2Icon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22.875 11V17C22.875 21 21.875 22 17.875 22H7.875C3.875 22 2.875 21 2.875 17V7C2.875 3 3.875 2 7.875 2H9.375C10.875 2 11.205 2.44 11.775 3.2L13.275 5.2C13.655 5.7 13.875 6 14.875 6H17.875C21.875 6 22.875 7 22.875 11Z",
		stroke: "#A0A0A0",
		strokeWidth: 1.5,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.875 2H17.875C19.875 2 20.875 3 20.875 5V6.38",
		stroke: "#A0A0A0",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFolder2Icon;
